import './navbar.scss'
import clsx from 'clsx'
import { useState } from 'react'
import { NavbarSettings } from '../NavbarSettings/NavbarSettings'
import { NavbarBottom } from '../NavbarBottom/NavbarBottom'
import { NavbarAnalytics } from '../NavbarAnalytics/NavbarAnalytics'
import { NavbarReferral } from '../NavbarReferral/NavbarReferral'
// import { useOutletContext } from 'react-router'

export type NavbarProps = {
    className?: string
}
export const Navbar = ({ className }: NavbarProps) => {
    // const context = useOutletContext()
    // console.log({ context, component: 'Navbar' })

    const [isOpen, setIsOpen] = useState(true)

    const toggleSidebar = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div className={clsx('navbar', { closed: !isOpen }, className)}>
            <nav className="navbar__container">
                <NavbarAnalytics />
                {/* <NavbarYandex isOpen={isOpen} /> */}
                <NavbarReferral />
                <NavbarSettings isOpen={isOpen} />
                <NavbarBottom isOpen={isOpen} toggleSidebar={toggleSidebar} />
            </nav>
        </div>
    )
}
